export class FormatChecker {
    static getFormat(path: string): string {
        return path.split('.').pop().trim().toLowerCase();
    }

    static isM3u8(path: string): boolean {
        return this.getFormat(path) === 'm3u8';
    }

    static isXml(path: string): boolean {
        return this.getFormat(path) === 'xml';
    }

    static isJson(path: string): boolean {
        return this.getFormat(path) === 'json';
    }
}
